import { Filters, Tab } from "../Filters";
import { TAB_TYPES, SELECT_FILTER_STEP, LocationCodesTable } from "@/utils/constants/FleetDashboard.constants";

class CasingDurabilityFilters extends Filters {
    constructor() {
        super();
        this.tabs[0] = new Tab({
            title: SELECT_FILTER_STEP.INNERTAB_LOCATIONS.TITLE,
            switchTextLeft: SELECT_FILTER_STEP.INNERTAB_LOCATIONS.SWITCH_TEXT_LEFT,
            switchTextRight: SELECT_FILTER_STEP.INNERTAB_LOCATIONS.SWITCH_TEXT_RIGHT,
            checkboxLabel: SELECT_FILTER_STEP.INNERTAB_LOCATIONS.CHECKBOX_LABEL,
            fields: LocationCodesTable.fields,
            sortEnum: LocationCodesTable.sortEnum,
        });

        this.tabType = TAB_TYPES.CASING_DURABILITY;
    }

    tabs = {};
}

export {
    CasingDurabilityFilters
}